import { useLocales } from "../../../locales";
import { Typography, Stack, Box, Tooltip, } from "@mui/material";
import visa from '../../../assets/images/credit-cards/visa.svg'
import mastercard from '../../../assets/images/credit-cards/mastercard.svg'
import amex from '../../../assets/images/credit-cards/amex.svg'
import diners from '../../../assets/images/credit-cards/diners.svg'
import jcb from '../../../assets/images/credit-cards/jcb.svg'
import isracard from '../../../assets/images/credit-cards/isra.png'
import discover from '../../../assets/images/credit-cards/discover.svg'

const creditCardLogoMap = {
    Visa: visa,
    Mastercard: mastercard,
    AmericanExpress: amex,
    Diners: diners,
    JCB: jcb,
    Isracard: isracard,
    Discover: discover,
}

// fn that returns inline svg to be used in an img tag in the case that we don't have a logo for the credit card
const generateCreditCardLogo = ({ creditCard }) => {
    const svgString = `<svg width="70" height="48" viewBox="0 0 70 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <style>
            .txt { font: bold 20px sans-serif; }
        </style>
        <text x="50%" y ="50%" dominant-baseline="middle" text-anchor="middle" fill="black" class="txt">${creditCard}</text>
    </svg>
    `
    const base64Svg = btoa(svgString);
    const dataUrl = `data:image/svg+xml;base64,${base64Svg}`;
    return dataUrl
}

export const SupportedPaymentMethod = ({creditCards}) => {
    const { translate } = useLocales()
    if (!creditCards || !creditCards.length) return null
    // https://www.figma.com/design/5sCDh4719IbpdosCEyLfHY/Credit-Cards-and-Payment-Methods-Icons-(Community)?node-id=0-1&t=K15ztqJ6puMMLFSa-0
    return (
        <>
            <Typography sx={{textAlign: 'center', mb: 2}} variant="subtitle1">{translate('event_page.supported_payment_method')}</Typography>
            <Stack direction="row" gap={1} alignItems={'center'} justifyContent={'center'}>
                {creditCards.map((creditCard, index) => (
                    <Tooltip key={index} title={creditCard}>
                        <Box sx={{
                            borderRadius: 1,
                            border: 1,
                            borderColor: 'rgba(0, 0, 0, 0.23)',
                            overflow: 'hidden',
                   
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }} key={index}>
                            {creditCardLogoMap[creditCard] && <img style={{maxHeight: '48px'}}  src={creditCardLogoMap[creditCard]} alt={creditCard} />}
                            {!creditCardLogoMap[creditCard] && <img style={{maxHeight: '48px'}}  src={generateCreditCardLogo({creditCard})} alt={creditCard} />}
                        </Box>
                    </Tooltip>
                ))}
            </Stack>
        </>
    )
}